const ScreenshotsSection = () => {
  const screenshots = [
    {
      title: 'ホーム画面',
      image: 'https://static.readdy.ai/image/982cbef0933d5cb0c5a33b0250e14312/13fdf278726f3c56ab4311b319197974.jpeg',
    },
    {
      title: 'アルバム一覧',
      image: 'https://static.readdy.ai/image/982cbef0933d5cb0c5a33b0250e14312/2c9f58d20849de3cc9749ca38e585c75.jpeg',
    },
    {
      title: '日記一覧',
      image: 'https://static.readdy.ai/image/982cbef0933d5cb0c5a33b0250e14312/6be01c6d88968af3fa50eb76241d9fa9.jpeg',
    },
    {
      title: '成長記録グラフ',
      image: 'https://static.readdy.ai/image/982cbef0933d5cb0c5a33b0250e14312/4c66f880fb257d3b0a2cb3bcf3e8415d.jpeg',
    },
  ];

  return (
    <section id="screenshots" className="py-16 sm:py-20 md:py-24 bg-primary/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Title */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light font-maru text-text-primary leading-tight mb-4 px-4">
            アプリの画面
          </h2>
        </div>

        {/* Screenshots Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
          {screenshots.map((screenshot, index) => (
            <div key={index} className="flex flex-col items-center">
              <div className="bg-white rounded-2xl shadow-xl p-2 sm:p-3 hover:shadow-2xl transition-shadow duration-300 w-full">
                <img
                  src={screenshot.image}
                  alt={screenshot.title}
                  className="w-full h-auto rounded-xl object-cover object-top"
                />
              </div>
              <p className="text-text-secondary text-xs sm:text-sm text-center mt-3 sm:mt-4 font-medium">
                {screenshot.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScreenshotsSection;